// Travail unifié (AGENT-794) : ligne d'exécution commune, carte d'attente,
// À traiter à quatre sources et Activité enrichie. Monté sous la clé `work`.
// L'espagnol retombe sur le français (fallbackLng) tant qu'il n'est pas traduit.
export const workResources = {
  fr: {
    execution: {
      state: {
        queued: 'En file',
        running: 'En cours',
        awaiting_response: 'Réponse attendue',
        awaiting_approval: 'Approbation attendue',
        succeeded: 'Réussie',
        failed: 'Échouée',
        cancelled: 'Annulée',
        unknown: 'État inconnu',
      },
      started: 'Démarrée',
      runtime: 'Durée d’exécution',
      elapsed: 'Temps écoulé',
      cost: 'Coût',
      notAvailable: 'non disponible',
      technical: 'Détails techniques',
      rawRecord: 'Enregistrement brut',
      open: 'Ouvrir',
      blockedOutcome: 'Bloquée : {{reason}}',
    },
    wait: {
      reason: 'Raison',
      object: 'Objet concerné',
      since: 'Depuis',
      age: 'il y a {{value}}',
      expires: 'Expire',
      expected: 'Décision attendue',
      owner: 'Responsable',
      ownerUnresolved: 'identité non résolue',
      unavailable: 'indisponible',
      unknownReason: 'Raison non fournie',
      source: {
        thread: 'Fil Studio bloqué',
        plan: 'Plan Agent Spec à examiner',
        humanAction: 'Action humaine',
        frontDoor: 'Approbation de Workflow',
        job: 'Job bloqué',
      },
      kind: {
        approve_plan: 'Approbation d’un plan',
        secret_input: 'Saisie d’un secret',
        oauth_connect: 'Connexion à un service',
        expense_note: 'Note de frais',
      },
      expectedDecision: {
        thread: 'Répondre dans le fil',
        plan: 'Examiner puis approuver ou rejeter le plan',
        approve_plan: 'Approuver ou rejeter le plan',
        secret_input: 'Saisir le secret dans la page scellée',
        oauth_connect: 'Refuser la connexion (le parcours fournisseur n’est pas encore disponible)',
        elsewhere: 'Décider sur One, avec votre propre session',
        unsupported: 'Décision gérée par un autre parcours',
        budget_exceeded: 'Relever le budget du plan',
        effect_outcome_unknown: 'Vérifier l’effet avant toute reprise',
        runtime_stop_unknown: 'Confirmer l’arrêt du runtime',
        blocked: 'Examiner le blocage',
      },
      actions: {
        approve: 'Approuver',
        reject: 'Rejeter',
        refuse: 'Refuser la connexion',
        cancelSecret: 'Annuler la demande',
        openSealedPage: 'Ouvrir la page de saisie',
        openActivity: 'Ouvrir dans Activité',
        openThread: 'Ouvrir le fil',
        openPlan: 'Ouvrir le plan',
        readOnly: 'Lecture seule ici : la décision se prend sur One.',
        deciding: 'Décision…',
        decisionError: 'La décision n’a pas été enregistrée.',
        decisionConflict: 'Cette demande n’attend plus de décision. La liste est actualisée.',
        loadSurface: 'Charger le détail de la demande',
        surfaceError: 'Le détail de la demande est indisponible.',
      },
      related: {
        workflow: 'Workflow',
        thread: 'Fil',
        job: 'Job',
        graph: 'Plan d’exécution',
        plan: 'Plan',
      },
    },
    inbox: {
      description: 'Ce qui attend une décision humaine : fils bloqués, plans, actions humaines et jobs bloqués.',
      empty: 'Rien à traiter.',
      noMatch: 'Aucune attente ne correspond à ce filtre.',
      search: 'Rechercher une attente',
      filterAll: 'Tout',
      filter: {
        thread: 'Fils',
        plan: 'Plans',
        humanAction: 'Actions humaines',
        job: 'Jobs bloqués',
      },
      sourceUnavailable: 'Source indisponible : {{source}}.',
      humanActionsUnavailable: 'Les actions humaines sont indisponibles sur cette instance pour votre session.',
      noAgent: 'Sélectionnez un Agent pour voir ses fils et ses plans.',
      noApplication: 'Sélectionnez une Application pour voir ses jobs bloqués.',
    },
    activity: {
      initiatorFilter: 'Initiateur',
      initiatorAll: 'Tous',
      initiator: {
        human_session: 'Personne',
        application_member: 'Clé d’API',
        service: 'Assistant ou service',
        unknown: 'Initiateur inconnu',
      },
      summaryTitle: 'Résumé',
      summaryLine: '{{state}}. Démarrée {{started}}.',
      initiatedBy: 'Lancée par',
      attempt: 'Tentative',
      attemptValue: '{{current}} sur {{max}}',
      lease: 'Lease',
      leaseHolder: 'Détenteur',
      leaseStatus: { active: 'Active', released: 'Libérée', none: 'Aucune lease active' },
      fencingToken: 'Fencing token',
      attemptId: 'Tentative (ID)',
      leaseId: 'Lease (ID)',
      jobId: 'Job (ID)',
      noResultText: 'Le résultat ne contient pas de texte lisible ; voir les preuves.',
      trajectory: 'Trajectoire',
      evidence: 'Preuves',
      raiseBudget: 'Relever le budget',
      raiseBudgetTitle: 'Relever le budget du plan',
      raiseBudgetDescription: 'Le budget maximal passe de {{from}} à {{to}} unités mineures ({{currency}}). Le serveur refuse toute baisse.',
      raiseBudgetField: 'Nouveau budget maximal (unités mineures)',
      raiseBudgetConfirm: 'Relever',
      raiseBudgetCancel: 'Annuler',
      raiseBudgetInvalid: 'Le nouveau budget doit être un entier supérieur au budget actuel.',
      raiseBudgetError: 'Le budget n’a pas été relevé.',
      raiseBudgetConflict: 'Le plan a changé depuis votre lecture. Il est actualisé.',
      owner: 'Propriétaire',
      principal: { human: 'Personne connectée', application: 'Application', service: 'Service ou assistant', unknown: 'Principal inconnu' },
      approvals: {
        title: 'Approbations',
        initial: 'Approbation initiale',
        workflowStep: 'Étape de workflow',
        requested: 'Demandée',
        resolved: 'Décidée',
        expires: 'Expire',
        openInbox: 'Ouvrir À traiter',
        actionId: 'Approbation (ID)',
        status: { waiting: 'En attente', approved: 'Approuvée', rejected: 'Refusée', expired: 'Expirée', completed: 'Terminée', unknown: 'Statut inconnu' },
      },
      provenance: {
        title: 'Provenance',
        launchedBy: 'Lancé par',
        via: 'Via',
        agent: 'Agent',
        agentDeployed: 'Agent de cette instance',
        plan: 'Plan d’exécution',
        openPlan: 'Voir le plan dans Activité',
        thread: 'Fil Studio du Chef d’orchestre',
        openThread: 'Ouvrir le fil',
        node: 'Nœud du plan',
        parentJob: 'Job parent',
        openParentJob: 'Voir le job parent',
        none: 'Aucun',
      },
    },
  },
  en: {
    execution: {
      state: {
        queued: 'Queued',
        running: 'Running',
        awaiting_response: 'Awaiting response',
        awaiting_approval: 'Awaiting approval',
        succeeded: 'Succeeded',
        failed: 'Failed',
        cancelled: 'Cancelled',
        unknown: 'Unknown state',
      },
      started: 'Started',
      runtime: 'Runtime',
      elapsed: 'Elapsed',
      cost: 'Cost',
      notAvailable: 'not available',
      technical: 'Technical details',
      rawRecord: 'Raw record',
      open: 'Open',
      blockedOutcome: 'Blocked: {{reason}}',
    },
    wait: {
      reason: 'Reason',
      object: 'Related object',
      since: 'Since',
      age: '{{value}} ago',
      expires: 'Expires',
      expected: 'Expected decision',
      owner: 'Owner',
      ownerUnresolved: 'unresolved identity',
      unavailable: 'unavailable',
      unknownReason: 'No reason provided',
      source: {
        thread: 'Blocked Studio thread',
        plan: 'Agent Spec plan to review',
        humanAction: 'Human action',
        frontDoor: 'Workflow approval',
        job: 'Blocked job',
      },
      kind: {
        approve_plan: 'Plan approval',
        secret_input: 'Secret input',
        oauth_connect: 'Service connection',
        expense_note: 'Expense note',
      },
      expectedDecision: {
        thread: 'Reply in the thread',
        plan: 'Review, then approve or reject the plan',
        approve_plan: 'Approve or reject the plan',
        secret_input: 'Type the secret in the sealed page',
        oauth_connect: 'Refuse the connection (the provider flow is not available yet)',
        elsewhere: 'Decide on One, with your own session',
        unsupported: 'Decided through another flow',
        budget_exceeded: 'Raise the plan budget',
        effect_outcome_unknown: 'Check the effect before any resume',
        runtime_stop_unknown: 'Confirm the runtime stop',
        blocked: 'Review the block',
      },
      actions: {
        approve: 'Approve',
        reject: 'Reject',
        refuse: 'Refuse the connection',
        cancelSecret: 'Cancel the request',
        openSealedPage: 'Open the input page',
        openActivity: 'Open in Activity',
        openThread: 'Open thread',
        openPlan: 'Open plan',
        readOnly: 'Read-only here: the decision is made on One.',
        deciding: 'Deciding…',
        decisionError: 'The decision was not recorded.',
        decisionConflict: 'This request no longer awaits a decision. The list has been refreshed.',
        loadSurface: 'Load the request details',
        surfaceError: 'The request details are unavailable.',
      },
      related: {
        workflow: 'Workflow',
        thread: 'Thread',
        job: 'Job',
        graph: 'Execution plan',
        plan: 'Plan',
      },
    },
    inbox: {
      description: 'What awaits a human decision: blocked threads, plans, human actions and blocked jobs.',
      empty: 'Nothing to do.',
      noMatch: 'No pending item matches this filter.',
      search: 'Search pending items',
      filterAll: 'All',
      filter: {
        thread: 'Threads',
        plan: 'Plans',
        humanAction: 'Human actions',
        job: 'Blocked jobs',
      },
      sourceUnavailable: 'Source unavailable: {{source}}.',
      humanActionsUnavailable: 'Human actions are unavailable on this instance for your session.',
      noAgent: 'Select an Agent to see its threads and plans.',
      noApplication: 'Select an Application to see its blocked jobs.',
    },
    activity: {
      initiatorFilter: 'Initiator',
      initiatorAll: 'All',
      initiator: {
        human_session: 'Person',
        application_member: 'API key',
        service: 'Assistant or service',
        unknown: 'Unknown initiator',
      },
      summaryTitle: 'Summary',
      summaryLine: '{{state}}. Started {{started}}.',
      initiatedBy: 'Started by',
      attempt: 'Attempt',
      attemptValue: '{{current}} of {{max}}',
      lease: 'Lease',
      leaseHolder: 'Holder',
      leaseStatus: { active: 'Active', released: 'Released', none: 'No active lease' },
      fencingToken: 'Fencing token',
      attemptId: 'Attempt (ID)',
      leaseId: 'Lease (ID)',
      jobId: 'Job (ID)',
      noResultText: 'The result holds no readable text; see the evidence.',
      trajectory: 'Trajectory',
      evidence: 'Evidence',
      raiseBudget: 'Raise budget',
      raiseBudgetTitle: 'Raise the plan budget',
      raiseBudgetDescription: 'The maximum budget goes from {{from}} to {{to}} minor units ({{currency}}). The server refuses any decrease.',
      raiseBudgetField: 'New maximum budget (minor units)',
      raiseBudgetConfirm: 'Raise',
      raiseBudgetCancel: 'Cancel',
      raiseBudgetInvalid: 'The new budget must be an integer above the current budget.',
      raiseBudgetError: 'The budget was not raised.',
      raiseBudgetConflict: 'The plan changed since you read it. It has been refreshed.',
      owner: 'Owner',
      principal: { human: 'Signed-in person', application: 'Application', service: 'Assistant or service', unknown: 'Unknown principal' },
      approvals: {
        title: 'Approvals',
        initial: 'Initial approval',
        workflowStep: 'Workflow step',
        requested: 'Requested',
        resolved: 'Decided',
        expires: 'Expires',
        openInbox: 'Open Inbox',
        actionId: 'Approval (ID)',
        status: { waiting: 'Waiting', approved: 'Approved', rejected: 'Rejected', expired: 'Expired', completed: 'Completed', unknown: 'Unknown status' },
      },
      provenance: {
        title: 'Provenance',
        launchedBy: 'Launched by',
        via: 'Via',
        agent: 'Agent',
        agentDeployed: 'Agent of this instance',
        plan: 'Execution plan',
        openPlan: 'View the plan in Activity',
        thread: 'Chief of staff Studio thread',
        openThread: 'Open the thread',
        node: 'Plan node',
        parentJob: 'Parent job',
        openParentJob: 'View the parent job',
        none: 'None',
      },
    },
  },
} as const
